module.exports = __webpack_public_path__ + "static/media/open_showcase.eb7da75d.jpg";